module.exports = __webpack_public_path__ + "static/media/loader-white.44a375be.svg";